import { useEffect, useState } from 'react';
import 'css/index.css';
import App from 'App';

function AppLoading() {
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        const removeLoader = (removeImmediately = false) => {
            setIsReady(true);

            const loader = document.getElementById('app-loader');

            if (loader) {
                if (removeImmediately) {
                    loader.remove();
                } else {
                    loader.classList.add('loader-hidden');
                    setTimeout(() => loader.remove(), 300);
                }
            }
        };

        // Only show loading after 2000ms
        const loadTime = performance.now().toFixed(0);
        const loadingDuration = 3000;
        const minTime = 2000;
        const maxTime = minTime + loadingDuration;

        console.log(`🚀 App volledig geladen in: ${loadTime}ms`);

        if (loadTime < minTime || loadTime > maxTime) {
            removeLoader(true);
            return;
        }

        new Promise((resolve) => setTimeout(resolve, maxTime - loadTime)).then(() => {
            removeLoader();
        });
    }, []);

    return (
        <div className={`uk-width-1-1 uk-height-viewport app-transition ${isReady ? 'app-visible' : ''}`}>
            <App />
        </div>
    );
}

export default AppLoading;
